export const useUserChecklistsStore = () => {
  const userId = useCurrentUID();

  return useUserChecklists(userId)();
};
